import type {
  GetClaimReportParamsDTO,
  GetClaimReportsResponseDTO,
  GetTicketsReportLastMonthParamsDTO,
  GetTicketsReportLastMonthResponseDTO,
  GetTicketsReportScheduleParamsDTO,
  GetTicketsReportScheduleResponseDTO,
} from 'declarations/dto/reports';

import { get, post } from './api';

export const getTicketsReportLastMonthApi = async (
  params?: GetTicketsReportLastMonthParamsDTO
): Promise<GetTicketsReportLastMonthResponseDTO> => {
  const response = await get<GetTicketsReportLastMonthResponseDTO>(
    `/ticket-reports/last-month`,
    params
  );

  return response.data;
};

export const getClaimReportCardsApi = async (
  params?: GetClaimReportParamsDTO
): Promise<GetClaimReportsResponseDTO> => {
  const response = await get<{ reportCards: GetClaimReportsResponseDTO }>(
    `/invoice-reports/report-cards`,
    params
  );

  return response.data.reportCards;
};

export const postTicketsReportScheduleApi = async (
  params?: GetTicketsReportScheduleParamsDTO
): Promise<GetTicketsReportScheduleResponseDTO> => {
  const response = await post<GetTicketsReportScheduleResponseDTO>(
    `/ticket-reports/schedule`,
    params
  );

  return response.data;
};
